import { LwFormInput } from 'redesign';
import { FieldRenderer } from '../dynamic-field.types';

export const DynamicNumberField: FieldRenderer = (field, control, label) => (
  <LwFormInput
    key={field.key}
    name={`${field.key}`}
    label={label}
    control={control}
    rules={{ required: field.rules.required.value }}
  />
);
